import React from 'react'
import Head from 'next/head'
import { YMaps, Map, Placemark } from 'react-yandex-maps'
import { Segment, Container, Header } from 'semantic-ui-react'

import Layout from 'components/Layout'

const Contacts = () => {
  return (
    <>
      <Head>
        <title>Контакты компании Аврора Хоумс</title>
        <meta property="og:title" content="Контакты компании Аврора Хоумс" />
        <meta
          name="description"
          content="Возникли вопросы? Свяжитесь с нами любым удобным для вас способом. Контакты центрального офиса компании Аврора Хоумс."
        />
        <meta
          property="og:description"
          content="Возникли вопросы? Свяжитесь с нами любым удобным для вас способом. Контакты центрального офиса компании Аврора Хоумс."
        />
        <meta
          property="og:image"
          content={`/_next/image?url=${encodeURIComponent(
            '/img/projects/5/plane/5.jpg'
          )}&w=640&q=75`}
        />
      </Head>
      <Layout>
        <Segment style={{ padding: '2em 0em' }} vertical>
          <Container text>
            <Header as="h2">Офис и производство</Header>
            <p style={{ fontSize: '1.2em' }}>
              612260, Кировская обл, Яранский р-н, г. Яранск, ул. Карла Маркса, дом № 183
            </p>
            <div style={{ width: '100%', height: '300px' }}>
              <YMaps>
                <Map
                  defaultState={{
                    center: [57.279311, 47.887567],
                    zoom: 14,
                  }}
                  width={'100%'}
                  height={'100%'}
                >
                  <Placemark
                    geometry={[57.279311, 47.887567]}
                    properties={{ balloonContent: 'ООО "Аврора Хоумс"' }}
                    options={{ preset: 'islands#dotIcon', iconColor: '#ed4543' }}
                  />
                </Map>
              </YMaps>
            </div>
            <Header as="h2">Телефон</Header>
            <p style={{ fontSize: '1.2em' }}>
              <a href="tel:+79877096654">+7 987 709 66 54</a> <br />
              <a href="tel:+79613333737">+7 961 333 37 37</a>
            </p>
          </Container>
        </Segment>
      </Layout>
    </>
  )
}

export default Contacts
